// Sets all focusable descendants of a panel as tabbable or non-tabbable
const setPanelFocusable = (panel, focusable) => {
  panel.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(el => {
    if (focusable) {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', '-1');
    }
  });
};

// Finds the associated panel for a trigger, supporting button-inside-heading markup
const getPanel = (trigger, panelClass) => {
  const sibling = trigger.nextElementSibling;
  if (sibling?.classList.contains(panelClass)) return sibling;
  const headingSibling =
    trigger.closest('h1,h2,h3,h4,h5,h6')?.nextElementSibling;
  return headingSibling?.classList.contains(panelClass) ? headingSibling : null;
};

/* Mobile Footer menu drop downs */
const togglers = document.querySelectorAll('.footer-top .toggler');
if (togglers.length > 0) {
  const footerMobileQuery = window.matchMedia('(max-width: 1023px)');
  const syncFooterStates = [];
  const isMobile = () => footerMobileQuery.matches;

  togglers.forEach(toggler => {
    const panel = getPanel(toggler, 'toggle');

    const apply = expanded => {
      const mobile = isMobile();
      toggler.classList.toggle('active', expanded);
      toggler.setAttribute('aria-expanded', mobile ? expanded : true);
      if (panel) {
        panel.classList.toggle('active', expanded);
        panel.style.maxHeight =
          mobile && expanded ? `${panel.scrollHeight}px` : null;
        panel.setAttribute('aria-hidden', mobile ? !expanded : false);
        setPanelFocusable(panel, !mobile || expanded);
      }
    };

    apply(toggler.classList.contains('active'));
    toggler.addEventListener('click', () => {
      if (isMobile()) apply(!toggler.classList.contains('active'));
    });
    syncFooterStates.push(() => apply(toggler.classList.contains('active')));
  });

  footerMobileQuery.addEventListener('change', () => {
    syncFooterStates.forEach(syncState => syncState());
  });
}

/* Product Page Accordions */
const accordions = document.querySelectorAll('.accordion');
if (accordions.length > 0) {
  accordions.forEach(accordion => {
    const panel = getPanel(accordion, 'panel');

    const apply = expanded => {
      accordion.classList.toggle('active', expanded);
      accordion.setAttribute('aria-expanded', expanded);
      if (panel) {
        panel.style.maxHeight = expanded ? `${panel.scrollHeight}px` : null;
        panel.setAttribute('aria-hidden', !expanded);
        setPanelFocusable(panel, expanded);
      }
    };

    apply(accordion.classList.contains('active'));
    accordion.addEventListener('click', () =>
      apply(!accordion.classList.contains('active'))
    );
  });
}
